/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAnswerPrograms
 */
export interface UserAnswerPrograms {
    /**
     * 
     * @type {string}
     * @memberof UserAnswerPrograms
     */
    programName?: string;
}

export function UserAnswerProgramsFromJSON(json: any): UserAnswerPrograms {
    return UserAnswerProgramsFromJSONTyped(json, false);
}

export function UserAnswerProgramsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAnswerPrograms {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'programName': !exists(json, 'program-name') ? undefined : json['program-name'],
    };
}

export function UserAnswerProgramsToJSON(value?: UserAnswerPrograms | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'program-name': value.programName,
    };
}


